var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recognized-by__wrapper"},[_c('h2',[_vm._v("PROUDLY RECOGNIZED BY")]),_vm._v(" "),_c('homepage-recognized-by-carousel',{staticClass:"recognized-by__carousel"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }